import pluralize from 'pluralize'

import type { DotLookupResult } from '@/models/fillApplication'

/** "Bell Trucking LLC, Dallas TX, 6 power units" */
export function dotPreviewLine(result: DotLookupResult): string {
  const place = [result.city, result.state].filter(Boolean).join(' ')
  const units = result.powerUnits != null ? pluralize('power unit', result.powerUnits, true) : ''
  return [result.name, place, units].filter(Boolean).join(', ')
}

export function DotLookupPreview({ result }: { result: DotLookupResult }) {
  return (
    <div className="flex flex-col gap-0.5">
      <span className="text-ink-400 text-xs">FMCSA match for DOT {result.dotNumber}</span>
      <span className="font-semibold">{dotPreviewLine(result)}</span>
    </div>
  )
}
